module.exports = __webpack_public_path__ + "static/media/bg-tc.24d74452.jpg";